import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Search } from "./types";

export default {
  getPage: (
    apiInfo: ModuleApiInfo,
    args: Search.Api.GetPageRequest
  ): Promise<HttpApiResponse<Search.Api.GetPageResponse>> => api.get(apiInfo, `/api/site/v1/modules/search/page`, args)
};
